import { render, staticRenderFns } from "./CanteenOperationReport.vue?vue&type=template&id=922c2258&scoped=true&"
import script from "./CanteenOperationReport.vue?vue&type=script&lang=js&"
export * from "./CanteenOperationReport.vue?vue&type=script&lang=js&"
import style0 from "./CanteenOperationReport.vue?vue&type=style&index=0&id=922c2258&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922c2258",
  null
  
)

export default component.exports